/**
 * Single source of truth for the testerToken-encoded URL that lands a tester
 * at the testing harness for a specific job. Used by:
 *
 *   • the web Tester Portal's Active / In-Progress / Late-Submission cards
 *     (relative path — React Router resolves it),
 *   • the API's claim handler when populating `webTestLink` on the response
 *     (absolute, env-aware via `API_URL`),
 *   • the Discord Activity's claim hand-off and "Resume to submit" buttons
 *     (absolute, opened via the Embedded App SDK's `openExternalLink`).
 *
 * Keeping the URL shape in one place means the "TesterTestPage uses status,
 * not entry route, to decide which phase to show" invariant survives any
 * future route rename — the change lands here and ripples to all callers.
 */
export function buildTesterTestUrl(input) {
    const { jobId, testerToken, baseUrl } = input;
    const path = `/tester/test/${jobId}?testerToken=${encodeURIComponent(testerToken)}`;
    if (!baseUrl)
        return path;
    const trimmed = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
    return `${trimmed}${path}`;
}
//# sourceMappingURL=test-page-url.js.map